import { generateAutomationName } from "../../helpers/generateAutomationName";

export const widgetKeys = {
    header: generateAutomationName("project", ["rank", "widget", "header"]),
    banner: generateAutomationName("project", ["rank", "widget", "banner"]),
    scrapingBadge: generateAutomationName("project", ["rank", "widget", "scraping", "badge"]),
    domain: generateAutomationName("project", ["rank", "widget", "domain"]),
    country: generateAutomationName("project", ["rank", "widget", "country"]),
    source: generateAutomationName("project", ["rank", "widget", "source"]),
    viewButton: generateAutomationName("project", ["rank", "widget", "view", "button"]),
    carousel: generateAutomationName("project", ["rank", "widget", "carousel"]),
    carouselHeader: generateAutomationName("project", ["rank", "widget", "carousel", "header"]),
};

export const widgetItemKeys = {
    container: (name: string) => generateAutomationName("project", ["rank", "widget", "item", "container", name]),
    header: generateAutomationName("project", ["rank", "widget", "item", "header"]),
    title: (name: string) => generateAutomationName("project", ["rank", "widget", "item", "title", name]),
    change: (name: string) => generateAutomationName("project", ["rank", "widget", "item", "change", name]),
};

export const creationModalKeys = {
    container: generateAutomationName("project", ["rank", "widget", "creation", "modal"]),
    footer: generateAutomationName("project", ["rank", "widget", "creation", "modal", "footer"]),
    cancelButton: generateAutomationName("project", ["rank", "widget", "creation", "modal", "button"]),
    nextButton: generateAutomationName("project", ["rank", "widget", "creation", "modal", "next", "button"]),
    doneButton: generateAutomationName("project", ["rank", "widget", "creation", "modal", "done", "button"]),
    initialStep: {
        title: generateAutomationName("project", ["rank", "widget", "creation", "modal", "initial", "step", "title"]),
        description: generateAutomationName("project", [
            "rank",
            "widget",
            "creation",
            "modal",
            "initial",
            "step",
            "description",
        ]),
        competitorsDropdown: generateAutomationName("project", [
            "rank",
            "widget",
            "creation",
            "modal",
            "initial",
            "step",
            "competitors",
            "dropdown",
        ]),
        countryDropdown: generateAutomationName("project", [
            "rank",
            "widget",
            "creation",
            "modal",
            "initial",
            "step",
            "country",
            "dropdown",
        ]),
        sourceDropdown: generateAutomationName("project", [
            "rank",
            "widget",
            "creation",
            "modal",
            "initial",
            "step",
            "source",
            "dropdown",
        ]),
    },
    nameStep: {
        title: generateAutomationName("project", ["rank", "widget", "creation", "modal", "name", "step", "title"]),
        description: generateAutomationName("project", [
            "rank",
            "widget",
            "creation",
            "modal",
            "name",
            "step",
            "description",
        ]),
        label: generateAutomationName("project", ["rank", "widget", "creation", "modal", "name", "step", "label"]),
        input: generateAutomationName("project", ["rank", "widget", "creation", "modal", "name", "step", "input"]),
        banner: generateAutomationName("project", ["rank", "widget", "creation", "modal", "name", "step", "banner"]),
    },
};
